"use client";

import { useDesktopLayoutStore } from "@/lib/desktop-layout/store";
import { AgentChatView } from "@/components/agent/AgentChatView";
import { useVybeAgentChat } from "./useVybeAgentChat";

export default function AgentSidebarMockup() {
  const toggleAgentSidebar = useDesktopLayoutStore((s) => s.toggleAgentSidebar);
  const chat = useVybeAgentChat();

  return (
    <div className="flex h-full min-w-0 w-full flex-col overflow-hidden border-l border-border">
      <AgentChatView
        variant="sidebar"
        speechMode="append"
        chat={chat}
        onClose={toggleAgentSidebar}
      />
    </div>
  );
}
